const VirginIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112789)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FCFCFC"
      />
      <path
        d="M23.3972 13.9719C23.3972 12.096 21.8764 10.5752 20.0004 10.5752C18.1244 10.5752 16.6036 12.096 16.6036 13.9719H9.13086C9.13086 15.8189 10.7398 17.3163 12.5867 17.3163H12.4755C12.4755 19.1634 13.9727 20.6609 15.8199 20.6609C15.8199 22.2963 16.9945 23.6552 18.5456 23.9457L18.537 23.9652H21.4639L21.4552 23.9457C23.0065 23.655 24.1809 22.2962 24.1809 20.6609C26.0281 20.6609 27.5254 19.1634 27.5254 17.3163H27.414C29.2609 17.3163 30.8699 15.8189 30.8699 13.9719H23.3972Z"
        fill="#FFDA44"
      />
      <path
        d="M18.507 23.6182L16.4009 28.3731C17.5121 28.8248 18.7267 29.0759 20.0003 29.0759C21.2738 29.0759 22.4884 28.8249 23.5996 28.3731L21.4935 23.6182H18.507Z"
        fill="#FFDA44"
      />
      <path
        d="M15.6523 15.6426V21.4934C15.6523 24.8214 20.0002 25.8412 20.0002 25.8412C20.0002 25.8412 24.348 24.8214 24.348 21.4934V15.6426H15.6523Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.85008 20.1387L7.20156 26.7155L9.52859 20.1387H11.3045L7.91187 28.8343H6.49117L3.07422 20.1387H4.85008Z"
        fill="#338AF3"
      />
      <path d="M32.1743 28.8343V20.1387H33.8644V28.8343H32.1743Z" fill="#338AF3" />
      <path
        d="M17.3916 17.5322V24.6224C17.9893 25.0623 18.6325 25.3649 19.1307 25.5586V17.5322H17.3916Z"
        fill="#D80027"
      />
      <path
        d="M22.6093 17.5322V24.6224C22.0115 25.0623 21.3684 25.3649 20.8701 25.5586V17.5322H22.6093Z"
        fill="#D80027"
      />
      <path d="M15.6523 15.6426H24.348V18.4016H15.6523V15.6426Z" fill="#0052B4" />
    </g>
    <defs>
      <clipPath id="clip0_4152_112789">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VirginIslandsSvg;
